import {configuracionService} from "@/api/coreApi";

const state = {
  loading: false,
  params: null,
  error: null
};

const actions = {
  getParametros({commit}) {
    return new Promise((resolve, reject) => {
      commit('parametrosInit')

      configuracionService.getParametros()
        .then(response => {
          commit('parametrosSuccess', response.data)
          resolve()
        })
        .catch(error => {
          commit('parametrosFailure', error)
          reject()
        });
    })
  },
};

const mutations = {
  parametrosInit(mstate) {
    mstate.loading = true
  },
  parametrosSuccess(mstate, data) {
    mstate.loading = false
    mstate.params = JSON.parse(data.datos)
  },
  parametrosFailure(mstate, error) {
    mstate.loading = false
    mstate.error = error
  }
};

export const parametro = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};
